import { useMemo } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";
import { IdentityProviderChangeRequestResponse } from "@idw-types/data/identity-providers";

type SubmitIdentityProviderChangeRequestModalProps = {
    identityProviderName: string;
    onModalClose: () => void;
    onSubmitHandler: (onModalClose: () => void) => Promise<IdentityProviderChangeRequestResponse>;
};

export const SubmitIdentityProviderChangeRequestModal = (props: SubmitIdentityProviderChangeRequestModalProps) => {
    const {
        identityProviderName,
        onModalClose,
        onSubmitHandler
    } = props;

    const bodyElement = useMemo(() => {
        return (
            <div>
                <p>This action will <b>SUBMIT</b> the Change Request for the Identity Provider named <b>{identityProviderName}</b> for review.</p>
                <p>
                    After the Change Request has been reviewed, it will either be APPROVED or returned to an UNSUBMITTED status for corrections or modifications.
                    You may UNSUBMIT this Change Request at any time prior to completion of the review process if you would like to make changes.
                    You may also CANCEL the Change Request at any time prior to deployment using the CANCEL option.
                </p>
            </div>
        );
    }, []);

    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.SUBMIT}
            title={"Submit Identity Provider Change Request for Review"}
            body={bodyElement}
            buttonText={"Submit Change Request"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};